<template>
    <div class="card" v-if="technician">
        <div class="card-body p-2">
            <div class="row align-items-center">
                <div class="col-auto text-center">
                    <avatar type="circle" size="avatar-sm" :src="(technician.avatar || {}).preview"></avatar>
                </div>
                <div class="col ml-n3">
                    <h4 class="card-title mb-1">{{technician.name}}</h4>
                    <p class="small mb-0 text-muted">{{technician.contacts.primaryPhone}}</p>
                </div>
                <div class="col-auto">
                    <button class="btn btn-white btn-sm" @click="updateValue({_id: null})">
                        <i class="fe fe-x"></i>
                    </button>
                </div>
            </div>
            <div class="row"></div>
        </div>
    </div>
    <div v-else data-toggle="lists">
        <b-input-group class="input-group-merge">
            <b-form-input
                v-model.trim="query"
                @change="fetchTechnicians()"
                :autofocus="true"
                class="nofade form-control-prepended"
                :placeholder="$t('Search technician')"
            ></b-form-input>

            <div class="input-group-prepend">
                <div class="input-group-text">
                    <span class="fe fe-loader text-muted" v-if="areDataLoading"></span>
                    <span class="fe fe-x text-muted" v-else-if="query" @click="query=null"></span>
                    <span class="fe fe-search text-muted" v-else></span>
                </div>
            </div>
        </b-input-group>
        <ul class="list-group list mt-2 pointer" style="max-height:200px; overflow-y:scroll" v-if="technicians">
            <li
                class="list-group-item py-2"
                :class="{'active':index == currentFocus}"
                v-for="(technician, index) in technicians"
                :key="index"
                @click="updateValue(technician)"
            >
                <div class="row align-items-center">
                    <div class="col-auto p-1">
                        <avatar type="circle" size="avatar-sm" v-if="technician" :src="(technician.avatar || {}).preview"></avatar>
                    </div>
                    <div class="col">
                        <h4 class="mb-1 name">{{technician.name}}</h4>
                        <p class="small mb-0 text-muted">{{technician.contacts.primaryPhone}}</p>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import debounce from 'lodash/debounce';
import Avatar from '@/components/Avatar.vue'
import { mapActions, mapGetters, mapState } from 'vuex';
import { modalMixins } from '@/mixins/modal.js'


export default {
    components: {
        Avatar,
    },
    props: { value: null },
    mixins: [modalMixins],
    data() {
        return {
            query: null,
            currentFocus: 0,
            customer: {},
            params: {
                query: {
                    $limit: 3,
                    $sort: {
                        createdAt: -1
                    }
                }
            }
        }
    },

    computed: {
        ...mapState('technicians', { areDataLoading: 'isFindPending' }),
        ...mapGetters('technicians', { findTechniciansInStore: 'find', getTechnicianFromStore: 'get' }),

        technicians() {
            return this.findTechniciansInStore(this.params).data;
        },

        technician() {
            if (this.value) return this.getTechnicianFromStore(this.value);
        }
    },
    destroyed() {
    },
    created() {
        this.fetchTechnicians();
    },
    watch: {
        query: debounce(function (newVal) {
            if (newVal) {
                this.params.query.$limit = 10;
                this.params.query.$or = [
                    { name: { $regex: '^' + newVal, $options: "si" } },
                    { email: { $regex: '^' + newVal, $options: "si" } },
                ];
            } else {
                delete this.params.query.$or;
                this.params.query.$limit = 3;
            }
            this.fetchTechnicians();
        }, 300),

    },
    methods: {
        ...mapActions('technicians', { findTechnicians: 'find' }),

        updateValue(value) {
            this.query = '';
            this.$emit('input', value._id);
        },

        fetchTechnicians() {
            this.findTechnicians(this.params)
        },


    }
}
</script>

<style>

</style>
